/* eslint @typescript-eslint/no-explicit-any: 0 */

import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild, ViewChildren, inject } from '@angular/core'
import {SelectorModel} from './wheel-selector.models'
import {MatDialog} from "@angular/material/dialog";
import {
  WheelSelectorSetValueDialogComponent
} from "../wheel-selector-set-value-dialog/wheel-selector-set-value-dialog.component";
import {WheelAction, WheelActionCallbacks} from "../../model/WheelAction";
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgClass, NgStyle } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';

export interface WheelSelectorChangeEvent {
  gIndex: number;
  iIndex: number,
  value: string
}

@Component({
    selector: 'app-wheel-selector',
    templateUrl: './wheel-selector.component.html',
    styleUrls: ['./wheel-selector.component.scss'],
    imports: [MatIconButton, MatIcon, NgClass, NgStyle, TranslocoModule]
})
export class WheelSelectorComponent implements OnInit, AfterViewInit, OnDestroy {
  dialog = inject(MatDialog);

  @ViewChildren('pickerGroupLayer')
  pickerGroupLayer: any;
  @ViewChild('pickerHandleLayer', { static: true })
  pickerHandleLayer: any;

  // gain ou spot
  @Input() gain = false
  @Input() homeHasPossession = true

  @Input() data: SelectorModel[] = [];
  @Input() title = '';

  // Pour afficher le nom des équipes
  @Input() homeTeamName = '';
  @Input() awayTeamName = '';

  @Input() disabled = false;
  @Output() changeValue: EventEmitter<WheelSelectorChangeEvent> = new EventEmitter<WheelSelectorChangeEvent>();

  currentIndexList: number[] = [];

  lastCurrentIndexList: number[] = [];
  groupsRectList: any[] = [];
  touchOrMouse = {
    isTouchable: 'ontouchstart' in window,
    isMouseDown: false
  };
  draggingInfo: any = {
    isDragging: false,
    groupIndex: null,
    startPageY: null
  };
  itemPerDegree = 23;
  safeDoTimeoutId: any = null;

  ngOnInit() {
    this.currentIndexList = this.getInitialCurrentIndexList();

    this.lastCurrentIndexList = this.currentIndexList.slice();

    this.groupsRectList = new Array(this.data.length);

    this.eventsRegister();
    window.addEventListener('resize', this.safeGetRectsBindEvents.bind(this), {passive: true});
  }

  ngAfterViewInit() {
    // Pour corriger un bug
    // Quand le wheel est dans un popup ou un bottom sheet,
    // le positionnement n'est pas encore bon au ngAfterViewInit()
    setTimeout(() => {
      this.getGroupsRectList();
    }, 0)
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.safeGetRectsBindEvents.bind(this));
  }

  getTeamName(index: number) {
    if (index === 55) return ' '
    if (index < 55) {
      return this.homeHasPossession ? this.homeTeamName : this.awayTeamName
    } else {
      return this.homeHasPossession ? this.awayTeamName : this.homeTeamName
    }
  }

  /**
   * Sélectionne la valeur
   *
   *     genderSelector.setValue(0, 'Male')
   *
   * @param gIndex
   * @param value
   */
  setValue(gIndex: number, value: string) {
    const originalValue = this.getValue()
    const indexOf = this.getIndexOf(gIndex, value);
    if (indexOf === -1) {
      alert(`${value} n'a pas été trouvé.`)
      return
    }
    this.currentIndexList[gIndex] = indexOf

    // Emit event only if value changed
    if (originalValue !== value) {
      this.changeValue.emit({gIndex, iIndex: indexOf, value: value});
    }
  }

  public getValue(gIndex = 0): string {
    return this.data[gIndex].list[this.currentIndexList[gIndex]]
  }

  checkWheelAction(callback: WheelActionCallbacks) {
    switch (this.getValue()) {
      case WheelAction.TD:
        callback.touchdown()
        break;
      case WheelAction.Safety:
        callback.safety()
        break;
      case WheelAction.Simple:
        callback.simple()
        break;
      default:
        if (callback.reinit) {
          callback.reinit()
        }
        break;
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(WheelSelectorSetValueDialogComponent, {
      data: {
        gain: this.gain,
        homeHasPossession: this.homeHasPossession,
        displayPlusMinusButton: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.value) {
        const firstDataIndex = this.data.findIndex(data => !data.divider)

        // FIXME Dans app-select-gain, n'ajuste pas automatiquement le spot
        this.setValue(firstDataIndex, result.value);
      }
    });
  }

  onKeydown($event: any) {
    // Désactiver en attente de la correction de #190
    if ($event.key === '+') {
      this.increase()
      return
    }
    if ($event.key === '-') {
      this.decrease()
      return
    }
    if ($event.key === 'Enter') {
      this.openDialog()
      return;
    }
  }

  increase() {
    const firstDataIndex = this.data.findIndex(data => !data.divider)
    if (this.currentIndexList[firstDataIndex] < 110) {
      this.currentIndexList[firstDataIndex]++
      this.changeValue.emit({
        gIndex: firstDataIndex,
        iIndex: this.currentIndexList[firstDataIndex],
        value: this.getValue()
      });
    }
  }

  decrease() {
    const firstDataIndex = this.data.findIndex(data => !data.divider)
    if (this.currentIndexList[firstDataIndex] > 0) {
      this.currentIndexList[firstDataIndex]--
    }
    this.changeValue.emit({
      gIndex: firstDataIndex,
      iIndex: this.currentIndexList[firstDataIndex],
      value: this.getValue()
    });
  }

  focusPicker() {
    this.pickerHandleLayer.nativeElement.focus()
  }

  private getIndexOf(gIndex: number, value: string): number {
    return this.data[gIndex].list.indexOf(value)
  }

  getInitialCurrentIndexList(): number[]  {
    return this.data.map((item) => {
      const iCI = item.currentIndex;
      if (typeof iCI === 'number' && iCI >= 0 && item.list && item.list.length && iCI <= item.list.length - 1) {
        return Math.round(iCI);
      }
      return 0;
    });
  }

  safeGetRectsBindEvents() {
    if (this.safeDoTimeoutId) {
      clearTimeout(this.safeDoTimeoutId);
    }
    this.safeDoTimeoutId = setTimeout(() => {
      this.getGroupsRectList();
    }, 200);
  }

  getGroupsRectList() {
    if (this.pickerGroupLayer) {
      this.pickerGroupLayer.toArray().forEach((item: any, index: number) => {
        this.groupsRectList[index] = item.nativeElement.getBoundingClientRect();
      });
    }
  }

  eventsRegister() {
    const handleEventLayer = this.pickerHandleLayer.nativeElement;
    if (handleEventLayer) {
      this.addEventsForElement(handleEventLayer);
    }
  }

  addEventsForElement(el: any) {
    if (!this.isTouchable) {
      el.removeEventListener('wheel', this.handleWheel, false);
      el.addEventListener('wheel', this.handleWheel.bind(this), {passive: true});
    }
  }

  isTouchable = this.touchOrMouse.isTouchable;

  // Mobile
  @HostListener('touchstart', ['$event'])
  onTouchStart(event: any) {
    const target = event.srcTarget || event.target
    if (['top', 'middle', 'bottom'].includes(target.getAttribute('data-type'))) {
      this.handleStart(event);
      return;
    }

    this.openDialog()
  }

  @HostListener('touchmove', ['$event'])
  onTouchMove(event: any) {
    this.handleMove(event);
  }

  @HostListener('touchend', ['$event'])
  onTouchEnd(event: any) {
    this.handleEnd(event);
  }

  @HostListener('touchcancel', ['$event'])
  onTouchCancel(event: any) {
    this.handleCancel(event);
  }

  @HostListener('touchdown', ['$event'])
  onTouchDown(event: any) {
    if (this.isTouchable) {
      this.handleStart(event);
    }
  }

  @HostListener('touchup', ['$event'])
  onTouchUp(event: any) {
    if (this.isTouchable) {
      this.handleEnd(event);
    }
  }

  @HostListener('touchleave', ['$event'])
  onTouchLeave(event: any) {
    if (this.isTouchable) {
      this.handleCancel(event);
    }
  }

  // Desktop
  @HostListener('mousedown', ['$event'])
  onMouseDown(event: any) {
    if (!this.isTouchable) {
      this.handleStart(event);
    }
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: any) {
    if (!this.isTouchable) {
      this.handleMove(event);
    }
  }

  @HostListener('mouseup', ['$event'])
  onMouseUp(event: any) {
    if (!this.isTouchable) {
      this.handleEnd(event);
    }
  }

  @HostListener('mouseleave', ['$event'])
  onMouseLeave(event: any) {
    if (!this.isTouchable) {
      this.handleCancel(event);
    }
  }

  getTouchInfo(ev: any) {
    return this.touchOrMouse.isTouchable ? ev.changedTouches[0] || ev.touches[0] : ev;
  }

  getGroupIndexBelongsEvent(ev: any): (number|null) {
    const touchInfo = this.getTouchInfo(ev);
    for (let i = 0; i < this.groupsRectList.length; i++) {
      const item = this.groupsRectList[i];
      if (item.left < touchInfo.pageX && touchInfo.pageX < item.right) {
        return i;
      }
    }

    return null;
  }

  handleStart(ev: any) {
    if (ev.cancelable) {
      ev.preventDefault();
      ev.stopPropagation();
    }
    const touchInfo = this.getTouchInfo(ev);
    this.draggingInfo.startPageY = touchInfo.pageY;
    if (!this.touchOrMouse.isTouchable) {
      this.touchOrMouse.isMouseDown = true;
    }
  }

  handleMove(ev: any) {
    if (ev.cancelable) {
      ev.preventDefault();
    }
    ev.stopPropagation();
    if (this.touchOrMouse.isTouchable || this.touchOrMouse.isMouseDown) {
      this.draggingInfo.isDragging = true;
      this.setCurrentIndexOnMove(ev);
    }
  }

  handleEnd(ev: any) {
    ev.preventDefault();
    ev.stopPropagation();
    this.draggingInfo.isDragging = false;
    this.touchOrMouse.isMouseDown = false;
    this.correctionAfterDragging(ev);
  }

  handleCancel(ev: any) {
    ev.preventDefault();
    ev.stopPropagation();
    if (this.touchOrMouse.isTouchable || this.touchOrMouse.isMouseDown) {
      this.correctionAfterDragging(ev);
      this.touchOrMouse.isMouseDown = false;
      this.draggingInfo.isDragging = false;
    }
  }

  // Pour empêcher de scroller la page
  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  handleWheel(ev: any) {
    this.setCurrentIndexOnWheel(ev);
    this.correctionAfterDragging(ev);
    this.focusPicker()
  }

  setCurrentIndexOnWheel(ev: any) {
    const gIndex = this.getGroupIndexBelongsEvent(ev);
    if (gIndex === null) return;

    if (this.data[gIndex].divider || !this.data[gIndex].list) {
      return;
    }

    const movedIndex = this.currentIndexList[gIndex] + (ev.deltaY / 153);
    this.currentIndexList[gIndex] = movedIndex;

    this.correctionCurrentIndex(ev, gIndex);
  }

  setCurrentIndexOnMove(ev: any) {
    const touchInfo = this.getTouchInfo(ev);
    if (this.draggingInfo.groupIndex === null) {
      this.draggingInfo.groupIndex = this.getGroupIndexBelongsEvent(ev);
    }
    const gIndex = this.draggingInfo.groupIndex;

    if (typeof gIndex === 'number' && (this.data[gIndex].divider || !this.data[gIndex].list)) {
      return;
    }
    const moveCount = (this.draggingInfo.startPageY - touchInfo.pageY) / 32;
    const movedIndex = this.currentIndexList[gIndex] + moveCount;
    this.currentIndexList[gIndex] = movedIndex;
    this.draggingInfo.startPageY = touchInfo.pageY;
  }

  correctionAfterDragging(ev: any) {
    const gIndex = this.draggingInfo.groupIndex || 0;
    this.correctionCurrentIndex(ev, gIndex);
    this.draggingInfo.groupIndex = null;
    this.draggingInfo.startPageY = null;
  }

  timeoutBuffer: (any|null) = null
  timeoutChangeEmit: (any|null) = null

  correctionCurrentIndex(ev: any, gIndex: number) {
    const BUFFER_MS = 200;
    // On utilise un timeout pour ne faire le calcul
    // qu'une seule fois, si correctionCurrentIndex est appelé plus d'une fois
    // en 200 ms. Ce qui arrive quand on scroll avec la souris.

    // Suppression des anciens timeOut en attente
    if (this.timeoutBuffer) clearTimeout(this.timeoutBuffer)
    if (this.timeoutChangeEmit) clearTimeout(this.timeoutChangeEmit)

    this.timeoutBuffer = setTimeout(() => {
      if (this.data[gIndex].divider !== true &&
        this.data[gIndex].list.length > 0
      ) {
        const unsafeGroupIndex = this.currentIndexList[gIndex];
        let movedIndex = unsafeGroupIndex;
        if (unsafeGroupIndex > this.data[gIndex].list.length - 1) {
          movedIndex = this.data[gIndex].list.length - 1;
        } else if (unsafeGroupIndex < 0) {
          movedIndex = 0;
        }
        movedIndex = Math.round(movedIndex);
        this.currentIndexList[gIndex] = movedIndex;
        if (movedIndex !== this.lastCurrentIndexList[gIndex]) {
          const currentValue = this.data[gIndex].list[movedIndex];

          if (this.timeoutChangeEmit) clearTimeout(this.timeoutChangeEmit)
          this.timeoutChangeEmit = window.setTimeout(() => {
            this.changeValue.emit({gIndex, iIndex: movedIndex, value: currentValue});
          }, 500)
        }
        this.lastCurrentIndexList = this.currentIndexList.slice();
      }
    }, BUFFER_MS);
  }

  isCurrentItem(gIndex: number, iIndex: number) {
    return this.currentIndexList[gIndex] === iIndex
  }

  getGroupClass(gIndex: number) {
    const group = this.data[gIndex]
    const defaultWeightClass = 'weight-' + (group.weight || 1)
    const groupClass = [defaultWeightClass]
    if (group.className) {
      groupClass.push(group.className)
    }
    return groupClass
  }

  getItemClass(gIndex: number, iIndex: number, isDivider = false) {
    const group = this.data[gIndex]
    const itemClass = []
    if (!isDivider && this.isCurrentItem(gIndex, iIndex)) {
      itemClass.push('smooth-item-selected')
    }
    if (group.textAlign) {
      itemClass.push('text-' + group.textAlign)
    }
    return itemClass
  }

  getItemStyle(gIndex: number, iIndex: number): any {
    const gapCount = this.currentIndexList[gIndex] - iIndex
    if (Math.abs(gapCount) < (90 / this.itemPerDegree)) {
      const rotateStyle: any = {
        transform: 'rotateX(' + gapCount * this.itemPerDegree + 'deg) translate3d(0, 0, 4em)',
        opacity: (3 - Math.abs(gapCount) / (90 / this.itemPerDegree)).toString()
      }
      if (!this.draggingInfo.isDragging) {
        rotateStyle['transition'] = 'transform 150ms ease-out'
      }
      return rotateStyle
    }
    if (gapCount > 0) {
      return {transform: 'rotateX(90deg) translate3d(0, 0, 5.625em)'}
    } else {
      return {transform: 'rotateX(-90deg) translate3d(0, 0, 5.625em)'}
    }
  }
}
